import mediaQuery from '@util/media-queries';

export default {

    async init () {
        let NavigationModule = null;
        const isDesktop = window.matchMedia( mediaQuery.min['screenLarge'] ).matches;
        const navContainer = isDesktop ? $( '#nav-lvl-primary' ) : $( '#nav-site--mobile' );

        if ( isDesktop && navContainer[0] ) {
            NavigationModule = await import( /*webpackChunkName: "~~desktopMenu"*/ './DesktopMenu' );
        }
        else if ( navContainer[0] ) {
            NavigationModule = await import( /*webpackChunkName: "~~mobileMenu"*/ './MobileMenu' );
        }

        if ( NavigationModule && NavigationModule.default ) {
            new NavigationModule.default( navContainer );
        }
    }
}
